export const TaxListToDisplay = {
  NO_TAX: 'NO TAX',
  EIGHTEEN_PERCENT_GST: '18% GST',
  FIFTEN_PERCENT_ST: '15% (14% ST + 0.5% KKC + 0.5% SBC)',
  FOUR_PERCENT_ST: '4.5% (4.2% ST + 0.15% KKC + 0.15% SBC)',
  FIVE_PERCENT_GST: '5% GST',
  SEVEN_PERCENT_VAT: '7% VAT',
  // TAX_APPLICABLE: 'TAX Applicable',
};

// export const TaxValueMap = {
//   NO_TAX: 0,
//   EIGHTEEN_PERCENT_GST: 18,
//   FIFTEN_PERCENT_ST: 15,
//   FOUR_PERCENT_ST: 4.5,
//   FIVE_PERCENT_GST: 5,
//   SEVEN_PERCENT_VAT: 7,
//   // TAX_APPLICABLE: 0,
// };

export const TaxValueMap = {
  'NO TAX': 0,
  '18% GST': 18,
  '15% (14% ST + 0.5% KKC + 0.5% SBC)': 15,
  '4.5% (4.2% ST + 0.15% KKC + 0.15% SBC)': 4.5,
  '5% GST': 5,
  '7% VAT': 7,
  // 'TAX Applicable': 0,
};

// export const TaxLabelMap = Object.keys(TaxValueMap).reduce((acc, key) => {
//   acc[TaxValueMap?.[key]] = key;
//   return acc;
// }, {});

// {
//   0: 'NO TAX',
//   18: '18% GST',
//   15: '15% (14% ST + 0.5% KKC + 0.5% SBC)',
//   4.5: '4.5% (4.2% ST + 0.15% KKC + 0.15% SBC)',
//   5: '5% GST',
//   7: '7% VAT',
//   'TAX Applicable': 0,
// }
